import React from "react";
import DocumentTypeForm from "../../document_type/form";
import {
  create as createDocumentType,
  update as updateDocumentType
} from "./axios";

const KarinLawDocumentTypeForm = props => {

  return(
    <>
      <DocumentTypeForm
        documentType={ props?.documentType || {} }
        data={ props?.data || {} }
        configuration={{
          context: 'karin_law',
          formName: 'karin_law_document_type',
          defaultRequestParams: {}
        }}
        actions={{
          createDocumentType: createDocumentType,
          updateDocumentType: updateDocumentType,
          indexDocumentTypesPath: Routes.karin_law_document_types_path,
          showDocumentTypePath: Routes.karin_law_document_type_path
        }}
      />
    </>
  )
}

export default KarinLawDocumentTypeForm;
